var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.position && _vm.position.id && _vm.position.positionsNr)?_c('span',[_c('b-overlay',{attrs:{"show":_vm.showOverlay,"rounded":"sm"}},[_c('ShowPositionInMap',{attrs:{"position-id":_vm.position.id,"position-nr":_vm.position.positionsNr}}),_vm._v("   "+_vm._s(_vm.position.positionsBesch)+" ")],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }